import { Helmet } from 'react-helmet';
import ProfileForm from '../../components/profile/ProfileForm';
import useFetchCredential from '../../hooks/useFetchCredential';

const EditProfile = () => {
  const { data, loading, error } = useFetchCredential(
    `${process.env.REACT_APP_API_URL}/marketers/dashboard`
  );

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Edit your Profile - Global Triumph Market Plus Multiconcept</title>
        <meta
          name="description"
          content="User profile editing page on Global Triumph Market Plus Multiconcept - Real estate investments and properties, properties for sales"
        />
      </Helmet>
      <div className="profile">
        {data && (
          <>
            <h1 className="pageTitle">Edit Profile</h1>
            <h3 className="subtitle">You can edit your user account here</h3>
            <ProfileForm data={data} />
          </>
        )}
        {loading && <div style={{ color: 'red !important', fontSize: '25px' }}>Loading...</div>}
        {error && <div style={{ color: 'red !important', fontSize: '25px' }}>{error}</div>}
      </div>
    </>
  );
};

export default EditProfile;
